/**
 * Texts for Library page
 */
export const libraryPageText = {
    title: 'CamAPS Liberty - CamAPS FX',
    titleMeta: 'CamAPS Liberty - CamAPS FX',
    descriptionMeta: 'Accede a recursos y materiales de apoyo para CamAPS FX y CamAPS Liberty®.',
    keywords: 'biblioteca camaps, camaps fx, camaps liberty, recursos de apoyo, gestión de la diabetes',
    localeMeta: 'es_es',

    bannerTitle: 'Apoyo más allá de los números',
    bannerSubtitle: 'con CamAPS Liberty<sup>®</sup>',
    bannerDescription: 'Cuando está activado, los usuarios no necesitarán contar carbohidratos ni administrar un bolo de insulina antes de las comidas.',
    bannerCompatibility: 'Compatible con Android e iOS',
    
    announcementText: 'Ya disponible en myLoop',
    announcementDisclaimer: '',

    introTitle: 'La primera función de circuito completamente cerrado. Cuando la necesite.',
    introDescription: 'Cuando se active, los usuarios no necesitarán contar carbohidratos ni administrar un bolo de insulina previo a las comidas.',
    introSubtext: 'Disponible en sistemas operativos Android y Apple',

    howItWorksTitle: '¿Cómo funciona?',
    howItWorksDescription: 'Impulsado por una versión más proactiva del algoritmo CamAPS. CamAPS Liberty anticipa y responde a los cambios de glucosa mientras mantiene los límites de seguridad establecidos.',
    
    step1Title: 'PASO 1',
    step1Description: 'Desde la pantalla de inicio, ve al menú de configuración.',
    step2Title: 'PASO 2',
    step2Description: 'Desplázate hacia abajo y toca el interruptor para activar.',
    step3Title: 'PASO 3',
    step3Description: 'En el primer uso, deberás ver nuestro video explicativo sobre CamAPS Liberty.',
    step4Title: 'PASO 4',
    step4Description: 'Confirma que no tienes menos de 13 años ni estás embarazada.',
    step5Title: 'PASO 5',
    step5Description: 'Toca el interruptor de nuevo para activar.',
    step6Title: 'PASO 6',
    step6Description: "Todo listo. La pestaña CamAPS Liberty aparecerá en la pantalla de inicio<sup>†</sup>.",
    step6Footnote: "<sup>†</sup> Solo funciona cuando el \"Auto mode\" está activado",

    eligibilityTitle: '¿Quién puede usar CamAPS Liberty?',
    eligibilityCriterion1: 'Usuarios existentes con diabetes tipo 1',
    eligibilityCriterion2: '13 años y mayores',
    eligibilityCriterion3: 'Embarazada',
    parentsCarersTitle: '¿Qué hay de los padres y cuidadores?',
    parentsCarersBlockTitle: 'Función "Bloqueo":',
    parentsCarersBlockDescription: 'Para evitar el uso accidental',
    parentsCarersRemoteTitle: 'Monitorización remota:',
    parentsCarersRemoteDescription: 'Companion, Glooko® e informes PDF de CamAPS de 2 semanas',

    imageOverlayText: 'Diseñado para funcionar junto con tu plan actual de manejo de la diabetes; no para reemplazarlo.',
    
    usingTitle: 'Usar CamAPS Liberty',
    
    treatmentPlanText: 'CamAPS Liberty está diseñada para eliminar la necesidad de administrar bolos rutinarios antes de las comidas. No sustituye los demás elementos del plan de tratamiento de la diabetes del usuario, incluida la revisión periódica con el equipo de diabetes.',
    
    usingLibertyTitle: 'Mire y aprenda sobre CamAPS Liberty',
    usingLibertyDescription: 'Explore vídeos para saber más sobre CamAPS Liberty y cómo empezar.',
    // latestVideoLabel removed
    moreVideosLabel: 'Más vídeos',
    factsheetDownloadText: 'Hoja informativa CamAPS Liberty (pdf)',
    factsheetUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/camaps_liberty_faqs_es.pdf',
    usingLibertyFeaturedVideo: {
        youtubeUrl: 'https://youtu.be/px9QSOhy544',
        title: 'CamAPS Liberty: Primeros pasos',
        description: 'Candice Ward explica cómo configurar y empezar a usar CamAPS Liberty.',
        duration: '31:50',
        date: '15 Sep 2026',
    },
    usingLibertyMoreVideos: [
        {
            youtubeUrl: 'https://youtu.be/ONnfBsgo5wE',
            title: 'Consejos prácticos: CamAPS Liberty',
            duration: '02:12',
        },
        {
            youtubeUrl: 'https://youtu.be/K7_j-Sk5Fas',
            title: 'Presentación de CamAPS Liberty',
            duration: '14:42',
        },
        {
            youtubeUrl: 'https://youtu.be/0dp5A8z_SEk',
            title: 'Esa sensación de fully closed-loop',
            duration: '04:22',
        },
        {
            youtubeUrl: 'https://youtu.be/huSshF0d8Ws',
            title: 'La función CamAPS Liberty',
            duration: '03:37',
        }
    ],
    
    whatHappensNextTitle: '¿Qué pasa después?',
    whatHappensNextText: 'Ejecutaremos un piloto dentro de un solo mercado en los próximos meses. Mantente atento para más detalles.',
};

